import baseUrl from '@/assets/js/baseUrl.js';
import http from './http'

export var companyApprove = {
  // 获取PC端审批中心列表
  getOaApprovalList(params) {
    return http.post(`${baseUrl}ApprovalCenter/oaApprovalList`, params)
  },
  // 获取PC端所申请人列表
  getPersonnelDataList(params) {
    return http.post(`${baseUrl}ApprovalCenter/personnelData`, params)
  },
  // 处理明细列表
  getOaExamineList(params) {
    return http.post(`${baseUrl}ApprovalCenter/oaExamineList`, params)
  },
  // 微信推送列表
  getWeChatWList(params) {
    return http.post(`${baseUrl}WeChat/wList`, params)
  },
  // 会务图片展示列表
  RotationList(params) {
    return http.post(`${baseUrl}Rotation/RotationList`, params)
  },


}



// WEBPACK FOOTER //
// ./src/api/companyApprove.js